var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.displayValue),expression:"displayValue"}],ref:"input",class:{
    'form-control': _vm.isFormControl,
    error: _vm.error
  },style:(_vm.styleInput),attrs:{"autocomplete":"off","placeholder":_vm.placeholder},domProps:{"value":(_vm.displayValue)},on:{"focus":_vm.onFocus,"blur":_vm.onBlur,"input":[function($event){if($event.target.composing){ return; }_vm.displayValue=$event.target.value},_vm.onInput]}})}
var staticRenderFns = []

export { render, staticRenderFns }